export default __webpack_public_path__ + "static/media/webchat.ce2c20c8.svg";